export default "__VITE_ASSET__Dki2Kj86__"